__turbopack_context__.v({
  "profileInfo": "_9KIYza_profileInfo",
  "vendorProfile": "_9KIYza_vendorProfile",
});
